export const blogListSkeleton = `
<div class="blog-post-card blog-post-skeleton">
    <div>
        <div class="image card-image card-image-top skeleton">
        </div>
    </div>
    <div class="card-content">
        <div class="card-overline">
            <span class="skeleton-word-25"></span>
            <span class="skeleton-word-25"></span>
            <span class="skeleton-word-25"></span>
        </div>
        <div class="card-title">
            <span class="skeleton-word-75"></span>
        </div>
        <div>
            <span class="skeleton-line"></span>
            <span class="skeleton-line"></span>
            <span class="skeleton-line"></span>
            <span class="skeleton-word-33"></span>
        </div>
        <div class="card-footer">
            <span class="skeleton-word-25"></span>
            <span class="skeleton-word-25"></span>
        </div>
    </div>
</div>
`;
